import { useNavigate } from "react-router-dom";
import "./NotificationPermission.css";

function NotificationPermission() {

  const navigate = useNavigate();

  const allowNotification = async () => {

    if ("Notification" in window) {

      await Notification.requestPermission();

    }

    navigate("/onboarding/location");

  };

  const skip = () => {

    navigate("/onboarding/location");

  };

  return (

    <div className="notify-page">

      <div className="notify-card">

        <div className="notify-icon">

          🔔

        </div>

        <h1>

          Stay Updated

        </h1>

        <p>

          Get instant notifications about

          <br />

          orders, offers and delivery updates.

        </p>

        <div className="notify-features">

          <div>✅ Live Order Updates</div>

          <div>🎁 Exclusive Offers</div>

          <div>🚚 Delivery Notifications</div>

        </div>

        <button

          className="allow-btn"

          onClick={allowNotification}

        >

          Allow Notifications

        </button>

        <button

          className="skip-btn"

          onClick={skip}

        >

          Not Now

        </button>

      </div>

    </div>

  );

}

export default NotificationPermission;